// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"825e55c40ccc7fdf439d","339":"72bb3800c8baf13ba2e4"}[chunkId] + ".js";
};